export default __webpack_public_path__ + "static/media/ceramol-acn3-rebalance-mat-960.ec123ddf.png";